// Public interface for client distribution library
const Calculation = require('../Calculation/Calculation');

module.exports = {
    calculateTax: function (policy, amount, stake) {
        const calculation = new Calculation(policy);
        return calculation.getResult(amount, stake);
    },
    policies: require('../TaxAuthority/PolicyCollection')
};